<template>
  <div class="mockup-preview-video" :style="style">
    <video v-if="!!current.src" controls ref="previewVideo">
      <source :src="current.src" type="video/mp4" />
    </video>
  </div>
</template>

<script>
var SCALE_HEIGHT = window.innerWidth * 0.5 - 32;
import { uploadPreviewAsset } from "@/api/catalog-api/mockup-preview-asset-api/mockupPreviewAsset.api.js";

export default {
  props: { current: Object },
  watch: {
    current: {
      handler() {
        const { current } = this;
        if (!!current.file)
          uploadPreviewAsset({
            file: current.file,
            jsClass: current.jsClass,
            order: current.order,
          }).then((r) => current.updateValues(r));
      },
      deep: true,
    },
  },
  computed: {
    style() {
      return {
        width: `${SCALE_HEIGHT}px`,
        height: `${SCALE_HEIGHT}px`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.mockup-preview-video {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: cornflowerblue;
  flex: none;
  margin-bottom: 6px;
  border-radius: 5px;

  video {
    width: inherit;
  }
}
</style>
